import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  ready: boolean;
  env: string;
}

const initialState: AppState = {
  ready: true,
  env: import.meta.env.VITE_APP_ENV ?? 'development',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setReady(state, action: PayloadAction<boolean>) {
      state.ready = action.payload;
    },
  },
});

export const { setReady } = appSlice.actions;
export default appSlice.reducer;
